var map = {
	"./accordion/accordion.module": [
		"./src/app/theme/ui-elements/basic/accordion/accordion.module.ts",
		"accordion-accordion-module"
	],
	"./add-on/add-on.module": [
		"./src/app/theme/forms/add-on/add-on.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"add-on-add-on-module"
	],
	"./adv-light-box/adv-light-box.module": [
		"./src/app/theme/ui-elements/advance/adv-light-box/adv-light-box.module.ts",
		"adv-light-box-adv-light-box-module"
	],
	"./adv-tree/adv-tree.module": [
		"./src/app/theme/ui-elements/advance/adv-tree/adv-tree.module.ts",
		"adv-tree-adv-tree-module"
	],
	"./advance-elements/advance-elements.module": [
		"./src/app/theme/forms/advance-elements/advance-elements.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"advance-elements-advance-elements-module~categories-category-module~components-create-order-create-o~79e42dec",
		"common",
		"advance-elements-advance-elements-module"
	],
	"./advance-widget/advance-widget.module": [
		"./src/app/theme/widget/advance-widget/advance-widget.module.ts",
		"advance-widget-advance-widget-module~analytics-analytics-module~chart-widget-chart-widget-module~crm~b10303fd",
		"advance-widget-advance-widget-module~analytics-analytics-module~chart-widget-chart-widget-module~def~a80a6cf7",
		"common",
		"advance-widget-advance-widget-module"
	],
	"./alert/alert.module": [
		"./src/app/theme/ui-elements/basic/alert/alert.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"alert-alert-module"
	],
	"./analytics/analytics.module": [
		"./src/app/theme/dashboard/analytics/analytics.module.ts",
		"analytics-analytics-module~chart-js-chart-js-module~chart-widget-chart-widget-module~crm-dashboard-c~7def8d34",
		"advance-widget-advance-widget-module~analytics-analytics-module~chart-widget-chart-widget-module~crm~b10303fd",
		"advance-widget-advance-widget-module~analytics-analytics-module~chart-widget-chart-widget-module~def~a80a6cf7",
		"common",
		"analytics-analytics-module"
	],
	"./basic-color/basic-color.module": [
		"./src/app/theme/ui-elements/basic/basic-color/basic-color.module.ts",
		"basic-color-basic-color-module"
	],
	"./basic-elements/basic-elements.module": [
		"./src/app/theme/forms/basic-elements/basic-elements.module.ts",
		"basic-elements-basic-elements-module"
	],
	"./basic-invoice/basic-invoice.module": [
		"./src/app/theme/extension/invoice/basic-invoice/basic-invoice.module.ts",
		"basic-invoice-basic-invoice-module"
	],
	"./basic-list/basic-list.module": [
		"./src/app/theme/ui-elements/basic/basic-list/basic-list.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"basic-list-basic-list-module"
	],
	"./basic-other/basic-other.module": [
		"./src/app/theme/ui-elements/basic/basic-other/basic-other.module.ts",
		"basic-other-basic-other-module"
	],
	"./best-selling/best-selling.module": [
		"./src/app/pages/reports/best-selling/best-selling.module.ts",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"best-selling-best-selling-module"
	],
	"./border/border.module": [
		"./src/app/theme/table/bootstrap-table/border/border.module.ts",
		"border-border-module"
	],
	"./box-shadow/box-shadow.module": [
		"./src/app/theme/ui-elements/basic/box-shadow/box-shadow.module.ts",
		"box-shadow-box-shadow-module"
	],
	"./branches/branch.module": [
		"./src/app/pages/master-data/branches/branch.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"common",
		"branches-branch-module"
	],
	"./breadcrumb/breadcrumb.module": [
		"./src/app/theme/ui-elements/basic/breadcrumb/breadcrumb.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"breadcrumb-breadcrumb-module"
	],
	"./button/button.module": [
		"./src/app/theme/ui-elements/basic/button/button.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"button-button-module"
	],
	"./c3-js/c3-js.module": [
		"./src/app/theme/chart/c3-js/c3-js.module.ts",
		"c3-js-c3-js-module"
	],
	"./carousel/carousel.module": [
		"./src/app/theme/ui-elements/advance/carousel/carousel.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"carousel-carousel-module"
	],
	"./categories/category-features/category-features.module": [
		"./src/app/pages/master-data/categories/category-features/category-features.module.ts",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"categories-category-features-category-features-module"
	],
	"./categories/category.module": [
		"./src/app/pages/master-data/categories/category.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"advance-elements-advance-elements-module~categories-category-module~components-create-order-create-o~79e42dec",
		"categories-category-module~dishe-dish-module~draggable-task-board-draggable-task-board-module~gift-c~738d3f85",
		"common",
		"categories-category-module"
	],
	"./category-report/category-report.module": [
		"./src/app/pages/reports/category-report/category-report.module.ts",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"category-report-category-report-module"
	],
	"./chart-js/chart-js.module": [
		"./src/app/theme/chart/chart-js/chart-js.module.ts",
		"analytics-analytics-module~chart-js-chart-js-module~chart-widget-chart-widget-module~crm-dashboard-c~7def8d34",
		"common",
		"chart-js-chart-js-module"
	],
	"./chart-widget/chart-widget.module": [
		"./src/app/theme/widget/chart-widget/chart-widget.module.ts",
		"analytics-analytics-module~chart-js-chart-js-module~chart-widget-chart-widget-module~crm-dashboard-c~7def8d34",
		"advance-widget-advance-widget-module~analytics-analytics-module~chart-widget-chart-widget-module~crm~b10303fd",
		"advance-widget-advance-widget-module~analytics-analytics-module~chart-widget-chart-widget-module~def~a80a6cf7",
		"chart-widget-chart-widget-module~crm-dashboard-crm-dashboard-module~radial-radial-module",
		"common",
		"chart-widget-chart-widget-module"
	],
	"./cities/city.module": [
		"./src/app/pages/master-data/cities/city.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"common",
		"cities-city-module"
	],
	"./components/all-orders-for-admin-branch/all-orders-for-admin-branch.module": [
		"./src/app/pages/orders/components/all-orders-for-admin-branch/all-orders-for-admin-branch.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"common",
		"components-all-orders-for-admin-branch-all-orders-for-admin-branch-module"
	],
	"./components/all-orders/all-orders.module": [
		"./src/app/pages/orders/components/all-orders/all-orders.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"common",
		"components-all-orders-all-orders-module"
	],
	"./components/create-order/create-order.module": [
		"./src/app/pages/orders/components/create-order/create-order.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"advance-elements-advance-elements-module~categories-category-module~components-create-order-create-o~79e42dec",
		"components-create-order-create-order-module~dishe-dish-module~gift-cards-gift-cards-module~gift-mess~e83febea",
		"common",
		"components-create-order-create-order-module"
	],
	"./components/order-details/order-details.module": [
		"./src/app/pages/orders/components/order-details/order-details.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"components-order-details-order-details-module"
	],
	"./components/orders-for-supervisor/orders-for-supervisor.module": [
		"./src/app/pages/orders/components/orders-for-supervisor/orders-for-supervisor.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"common",
		"components-orders-for-supervisor-orders-for-supervisor-module"
	],
	"./components/today-orders-for-admin-branch/today-orders-for-admin-branch.module": [
		"./src/app/pages/orders/components/today-orders-for-admin-branch/today-orders-for-admin-branch.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"components-today-orders-for-admin-branch-today-orders-for-admin-branch-module"
	],
	"./components/today-orders/today-orders.module": [
		"./src/app/pages/orders/components/today-orders/today-orders.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"common",
		"components-today-orders-today-orders-module"
	],
	"./crm-dashboard/crm-dashboard.module": [
		"./src/app/theme/dashboard/crm-dashboard/crm-dashboard.module.ts",
		"analytics-analytics-module~chart-js-chart-js-module~chart-widget-chart-widget-module~crm-dashboard-c~7def8d34",
		"advance-widget-advance-widget-module~analytics-analytics-module~chart-widget-chart-widget-module~crm~b10303fd",
		"crm-dashboard-crm-dashboard-module~data-widget-data-widget-module~default-default-module~google-map-~f75b742b",
		"chart-widget-chart-widget-module~crm-dashboard-crm-dashboard-module~radial-radial-module",
		"common",
		"crm-dashboard-crm-dashboard-module"
	],
	"./data-widget/data-widget.module": [
		"./src/app/theme/widget/data-widget/data-widget.module.ts",
		"analytics-analytics-module~chart-js-chart-js-module~chart-widget-chart-widget-module~crm-dashboard-c~7def8d34",
		"advance-widget-advance-widget-module~analytics-analytics-module~chart-widget-chart-widget-module~crm~b10303fd",
		"crm-dashboard-crm-dashboard-module~data-widget-data-widget-module~default-default-module~google-map-~f75b742b",
		"common",
		"data-widget-data-widget-module"
	],
	"./default/default.module": [
		"./src/app/theme/dashboard/default/default.module.ts",
		"analytics-analytics-module~chart-js-chart-js-module~chart-widget-chart-widget-module~crm-dashboard-c~7def8d34",
		"advance-widget-advance-widget-module~analytics-analytics-module~chart-widget-chart-widget-module~crm~b10303fd",
		"advance-widget-advance-widget-module~analytics-analytics-module~chart-widget-chart-widget-module~def~a80a6cf7",
		"crm-dashboard-crm-dashboard-module~data-widget-data-widget-module~default-default-module~google-map-~f75b742b",
		"common",
		"default-default-module"
	],
	"./dishe/dish.module": [
		"./src/app/pages/dishes/dishe/dish.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"components-create-order-create-order-module~dishe-dish-module~gift-cards-gift-cards-module~gift-mess~e83febea",
		"categories-category-module~dishe-dish-module~draggable-task-board-draggable-task-board-module~gift-c~738d3f85",
		"common",
		"dishe-dish-module"
	],
	"./draggable-task-board/draggable-task-board.module": [
		"./src/app/theme/ui-elements/advance/draggable-task-board/draggable-task-board.module.ts",
		"categories-category-module~dishe-dish-module~draggable-task-board-draggable-task-board-module~gift-c~738d3f85",
		"common",
		"draggable-task-board-draggable-task-board-module"
	],
	"./ecommerce/ecommerce.module": [
		"./src/app/theme/dashboard/ecommerce/ecommerce.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"analytics-analytics-module~chart-js-chart-js-module~chart-widget-chart-widget-module~crm-dashboard-c~7def8d34",
		"advance-widget-advance-widget-module~analytics-analytics-module~chart-widget-chart-widget-module~crm~b10303fd",
		"common",
		"ecommerce-ecommerce-module"
	],
	"./email-compose/email-compose.module": [
		"./src/app/theme/email/email-compose/email-compose.module.ts",
		"email-compose-email-compose-module~quill-edit-quill-edit-module~user-profile-user-profile-module",
		"common",
		"email-compose-email-compose-module"
	],
	"./email-inbox/email-inbox.module": [
		"./src/app/theme/email/email-inbox/email-inbox.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"email-inbox-email-inbox-module"
	],
	"./email-read/email-read.module": [
		"./src/app/theme/email/email-read/email-read.module.ts",
		"email-read-email-read-module"
	],
	"./form-mask/form-mask.module": [
		"./src/app/theme/forms/form-mask/form-mask.module.ts",
		"form-mask-form-mask-module"
	],
	"./form-picker/form-picker.module": [
		"./src/app/theme/forms/form-picker/form-picker.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"form-picker-form-picker-module"
	],
	"./form-select/form-select.module": [
		"./src/app/theme/forms/form-select/form-select.module.ts",
		"advance-elements-advance-elements-module~categories-category-module~components-create-order-create-o~79e42dec",
		"common",
		"form-select-form-select-module"
	],
	"./form-validation/form-validation.module": [
		"./src/app/theme/forms/form-validation/form-validation.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"form-validation-form-validation-module"
	],
	"./form-wizards/form-wizards.module": [
		"./src/app/theme/forms/form-wizards/form-wizards.module.ts",
		"form-wizards-form-wizards-module~pages-admin-data-admin-data-module~pages-boxes-boxes-module~pages-d~387b3d7a",
		"common",
		"form-wizards-form-wizards-module"
	],
	"./generic-class/generic-class.module": [
		"./src/app/theme/ui-elements/basic/generic-class/generic-class.module.ts",
		"generic-class-generic-class-module"
	],
	"./gift-cards/gift-cards.module": [
		"./src/app/pages/gift-card/gift-cards/gift-cards.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"advance-elements-advance-elements-module~categories-category-module~components-create-order-create-o~79e42dec",
		"components-create-order-create-order-module~dishe-dish-module~gift-cards-gift-cards-module~gift-mess~e83febea",
		"categories-category-module~dishe-dish-module~draggable-task-board-draggable-task-board-module~gift-c~738d3f85",
		"gift-cards-gift-cards-module~gift-message-design-category-gift-message-design-category-module~pages-~51b16377",
		"common",
		"gift-cards-gift-cards-module"
	],
	"./gift-category/gift-category.module": [
		"./src/app/pages/gift-card/gift-category/gift-category.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"gift-category-gift-category-module"
	],
	"./gift-message-design-category/gift-message-design-category.module": [
		"./src/app/pages/gift-card/gift-message-design-category/gift-message-design-category.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"advance-elements-advance-elements-module~categories-category-module~components-create-order-create-o~79e42dec",
		"components-create-order-create-order-module~dishe-dish-module~gift-cards-gift-cards-module~gift-mess~e83febea",
		"gift-cards-gift-cards-module~gift-message-design-category-gift-message-design-category-module~pages-~51b16377",
		"common",
		"gift-message-design-category-gift-message-design-category-module"
	],
	"./google-chart/google-chart.module": [
		"./src/app/theme/chart/google-chart/google-chart.module.ts",
		"google-chart-google-chart-module"
	],
	"./google-map/google-map.module": [
		"./src/app/theme/map/google-map/google-map.module.ts",
		"crm-dashboard-crm-dashboard-module~data-widget-data-widget-module~default-default-module~google-map-~f75b742b",
		"common",
		"google-map-google-map-module"
	],
	"./grid-stack/grid-stack.module": [
		"./src/app/theme/ui-elements/advance/grid-stack/grid-stack.module.ts",
		"grid-stack-grid-stack-module"
	],
	"./home-titles/home.titles.module": [
		"./src/app/pages/master-data/home-titles/home.titles.module.ts",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"common",
		"home-titles-home-titles-module"
	],
	"./invoice-list/invoice-list.module": [
		"./src/app/theme/extension/invoice/invoice-list/invoice-list.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"invoice-list-invoice-list-module"
	],
	"./invoice-summary/invoice-summary.module": [
		"./src/app/theme/extension/invoice/invoice-summary/invoice-summary.module.ts",
		"analytics-analytics-module~chart-js-chart-js-module~chart-widget-chart-widget-module~crm-dashboard-c~7def8d34",
		"common",
		"invoice-summary-invoice-summary-module"
	],
	"./items-without-sale/items-without-sale.module": [
		"./src/app/pages/reports/items-without-sale/items-without-sale.module.ts",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"items-without-sale-items-without-sale-module"
	],
	"./job/components/applayed-jobs/applay-jobs.module": [
		"./src/app/pages/jobs/job/components/applayed-jobs/applay-jobs.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"job-components-applayed-jobs-applay-jobs-module~job-job-module",
		"common",
		"job-components-applayed-jobs-applay-jobs-module"
	],
	"./job/job.module": [
		"./src/app/pages/jobs/job/job.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"job-components-applayed-jobs-applay-jobs-module~job-job-module",
		"common",
		"job-job-module"
	],
	"./label-badge/label-badge.module": [
		"./src/app/theme/ui-elements/basic/label-badge/label-badge.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"label-badge-label-badge-module"
	],
	"./modal/modal.module": [
		"./src/app/theme/ui-elements/advance/modal/modal.module.ts",
		"modal-modal-module"
	],
	"./ngx-wizard/ngx-wizard.module": [
		"./src/app/theme/forms/ngx-wizard/ngx-wizard.module.ts",
		"ngx-wizard-ngx-wizard-module"
	],
	"./notification/notification.module": [
		"./src/app/theme/ui-elements/advance/notification/notification.module.ts",
		"notification-notification-module"
	],
	"./other-datatable/other-datatable.module": [
		"./src/app/theme/table/data-table/other-datatable/other-datatable.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"other-datatable-other-datatable-module~task-issue-task-issue-module~task-list-task-list-module~theme~860ba759",
		"common",
		"other-datatable-other-datatable-module"
	],
	"./pages/admin-data/admin-data.module": [
		"./src/app/pages/admin-data/admin-data.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"advance-elements-advance-elements-module~categories-category-module~components-create-order-create-o~79e42dec",
		"components-create-order-create-order-module~dishe-dish-module~gift-cards-gift-cards-module~gift-mess~e83febea",
		"form-wizards-form-wizards-module~pages-admin-data-admin-data-module~pages-boxes-boxes-module~pages-d~387b3d7a",
		"common",
		"pages-admin-data-admin-data-module"
	],
	"./pages/boxes/boxes.module": [
		"./src/app/pages/boxes/boxes.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"advance-elements-advance-elements-module~categories-category-module~components-create-order-create-o~79e42dec",
		"components-create-order-create-order-module~dishe-dish-module~gift-cards-gift-cards-module~gift-mess~e83febea",
		"form-wizards-form-wizards-module~pages-admin-data-admin-data-module~pages-boxes-boxes-module~pages-d~387b3d7a",
		"common",
		"pages-boxes-boxes-module"
	],
	"./pages/contact-us/contact-us.module": [
		"./src/app/pages/contact-us/contact-us.module.ts",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"pages-contact-us-contact-us-module"
	],
	"./pages/corporate-gifts/corporate-gifts.module": [
		"./src/app/pages/corporate-gifts/corporate-gifts.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"components-create-order-create-order-module~dishe-dish-module~gift-cards-gift-cards-module~gift-mess~e83febea",
		"common",
		"pages-corporate-gifts-corporate-gifts-module"
	],
	"./pages/coupon-codes/coupon-codes.module": [
		"./src/app/pages/coupon-codes/coupon-codes.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"pages-coupon-codes-coupon-codes-module"
	],
	"./pages/custom-list/components/product-custom-list/product-custom-list.module": [
		"./src/app/pages/custom-list/components/product-custom-list/product-custom-list.module.ts",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"advance-elements-advance-elements-module~categories-category-module~components-create-order-create-o~79e42dec",
		"categories-category-module~dishe-dish-module~draggable-task-board-draggable-task-board-module~gift-c~738d3f85",
		"gift-cards-gift-cards-module~gift-message-design-category-gift-message-design-category-module~pages-~51b16377",
		"common",
		"pages-custom-list-components-product-custom-list-product-custom-list-module"
	],
	"./pages/custom-list/custom-list.module": [
		"./src/app/pages/custom-list/custom-list.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"common",
		"pages-custom-list-custom-list-module"
	],
	"./pages/delevery/delevery.module": [
		"./src/app/pages/delevery/delevery.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"form-wizards-form-wizards-module~pages-admin-data-admin-data-module~pages-boxes-boxes-module~pages-d~387b3d7a",
		"common",
		"pages-delevery-delevery-module"
	],
	"./pages/delevery/supervisors/supervisors.module": [
		"./src/app/pages/delevery/supervisors/supervisors.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"advance-elements-advance-elements-module~categories-category-module~components-create-order-create-o~79e42dec",
		"components-create-order-create-order-module~dishe-dish-module~gift-cards-gift-cards-module~gift-mess~e83febea",
		"form-wizards-form-wizards-module~pages-admin-data-admin-data-module~pages-boxes-boxes-module~pages-d~387b3d7a",
		"common",
		"pages-delevery-supervisors-supervisors-module"
	],
	"./pages/dishes/dishes.module": [
		"./src/app/pages/dishes/dishes.module.ts",
		"pages-dishes-dishes-module"
	],
	"./pages/gift-card/gift-card.module": [
		"./src/app/pages/gift-card/gift-card.module.ts",
		"pages-gift-card-gift-card-module"
	],
	"./pages/jobs/jobs.module": [
		"./src/app/pages/jobs/jobs.module.ts",
		"pages-jobs-jobs-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"pages-login-login-module"
	],
	"./pages/master-data/master-data.module": [
		"./src/app/pages/master-data/master-data.module.ts",
		"pages-master-data-master-data-module"
	],
	"./pages/orders/orders.module": [
		"./src/app/pages/orders/orders.module.ts",
		"pages-orders-orders-module"
	],
	"./pages/registration/registration.module": [
		"./src/app/pages/registration/registration.module.ts",
		"pages-registration-registration-module"
	],
	"./pages/reports/reports.module": [
		"./src/app/pages/reports/reports.module.ts",
		"pages-reports-reports-module"
	],
	"./pages/slider-info/slider-info.module": [
		"./src/app/pages/slider-info/slider-info.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"pages-slider-info-slider-info-module"
	],
	"./pages/slider2-photo/slider2-photo.module": [
		"./src/app/pages/slider2-photo/slider2-photo.module.ts",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"pages-slider2-photo-slider2-photo-module"
	],
	"./pages/store-locations/store-location.module": [
		"./src/app/pages/store-locations/store-location.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"pages-store-locations-store-location-module"
	],
	"./pages/up-to-message/up-to-message.module": [
		"./src/app/pages/up-to-message/up-to-message.module.ts",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"pages-up-to-message-up-to-message-module"
	],
	"./pages/user-messages/user-message.module": [
		"./src/app/pages/user-messages/user-message.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"pages-user-messages-user-message-module"
	],
	"./paging/paging.module": [
		"./src/app/theme/table/data-table/paging/paging.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"paging-paging-module"
	],
	"./pre-loader/pre-loader.module": [
		"./src/app/theme/ui-elements/basic/pre-loader/pre-loader.module.ts",
		"pre-loader-pre-loader-module"
	],
	"./productes/product.module": [
		"./src/app/pages/master-data/productes/product.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"branches-branch-module~categories-category-module~cities-city-module~components-all-orders-all-order~2e38c3dd",
		"advance-elements-advance-elements-module~categories-category-module~components-create-order-create-o~79e42dec",
		"components-create-order-create-order-module~dishe-dish-module~gift-cards-gift-cards-module~gift-mess~e83febea",
		"categories-category-module~dishe-dish-module~draggable-task-board-draggable-task-board-module~gift-c~738d3f85",
		"common",
		"productes-product-module"
	],
	"./productes/productes-features/producte-features.module": [
		"./src/app/pages/master-data/productes/productes-features/producte-features.module.ts",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"productes-productes-features-producte-features-module"
	],
	"./progressbar/progressbar.module": [
		"./src/app/theme/ui-elements/basic/progressbar/progressbar.module.ts",
		"progressbar-progressbar-module"
	],
	"./project/project.module": [
		"./src/app/theme/dashboard/project/project.module.ts",
		"analytics-analytics-module~chart-js-chart-js-module~chart-widget-chart-widget-module~crm-dashboard-c~7def8d34",
		"advance-widget-advance-widget-module~analytics-analytics-module~chart-widget-chart-widget-module~def~a80a6cf7",
		"common",
		"project-project-module"
	],
	"./quill-edit/quill-edit.module": [
		"./src/app/theme/extension/editor/quill-edit/quill-edit.module.ts",
		"email-compose-email-compose-module~quill-edit-quill-edit-module~user-profile-user-profile-module",
		"common",
		"quill-edit-quill-edit-module"
	],
	"./radial/radial.module": [
		"./src/app/theme/chart/radial/radial.module.ts",
		"chart-widget-chart-widget-module~crm-dashboard-crm-dashboard-module~radial-radial-module",
		"common",
		"radial-radial-module"
	],
	"./range-slider/range-slider.module": [
		"./src/app/theme/ui-elements/advance/range-slider/range-slider.module.ts",
		"range-slider-range-slider-module"
	],
	"./rating/rating.module": [
		"./src/app/theme/ui-elements/advance/rating/rating.module.ts",
		"rating-rating-module"
	],
	"./row-details/row-details.module": [
		"./src/app/theme/table/data-table/row-details/row-details.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"row-details-row-details-module"
	],
	"./selection/selection.module": [
		"./src/app/theme/table/data-table/selection/selection.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"selection-selection-module"
	],
	"./sizing/sizing.module": [
		"./src/app/theme/table/bootstrap-table/sizing/sizing.module.ts",
		"sizing-sizing-module"
	],
	"./statistic/statistic.module": [
		"./src/app/theme/widget/statistic/statistic.module.ts",
		"statistic-statistic-module"
	],
	"./store-anlysis/store-anlysis.module": [
		"./src/app/pages/reports/store-anlysis/store-anlysis.module.ts",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"store-anlysis-store-anlysis-module"
	],
	"./styling/styling.module": [
		"./src/app/theme/table/bootstrap-table/styling/styling.module.ts",
		"styling-styling-module"
	],
	"./table-basic-data/table-basic-data.module": [
		"./src/app/theme/table/data-table/table-basic-data/table-basic-data.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"table-basic-data-table-basic-data-module"
	],
	"./table-basic/table-basic.module": [
		"./src/app/theme/table/bootstrap-table/table-basic/table-basic.module.ts",
		"table-basic-table-basic-module"
	],
	"./table-edit/table-edit.module": [
		"./src/app/theme/table/data-table/table-edit/table-edit.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"table-edit-table-edit-module"
	],
	"./tabs/tabs.module": [
		"./src/app/theme/ui-elements/basic/tabs/tabs.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"tabs-tabs-module"
	],
	"./task-board/task-board.module": [
		"./src/app/theme/task/task-board/task-board.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"task-board-task-board-module"
	],
	"./task-details/task-details.module": [
		"./src/app/theme/task/task-details/task-details.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"task-details-task-details-module"
	],
	"./task-issue/task-issue.module": [
		"./src/app/theme/task/task-issue/task-issue.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"other-datatable-other-datatable-module~task-issue-task-issue-module~task-list-task-list-module~theme~860ba759",
		"common",
		"task-issue-task-issue-module"
	],
	"./task-list/task-list.module": [
		"./src/app/theme/task/task-list/task-list.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"other-datatable-other-datatable-module~task-issue-task-issue-module~task-list-task-list-module~theme~860ba759",
		"common",
		"task-list-task-list-module"
	],
	"./theme/chart/chart.module": [
		"./src/app/theme/chart/chart.module.ts",
		"theme-chart-chart-module"
	],
	"./theme/crm-contact/crm-contact.module": [
		"./src/app/theme/crm-contact/crm-contact.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"other-datatable-other-datatable-module~task-issue-task-issue-module~task-list-task-list-module~theme~860ba759",
		"common",
		"theme-crm-contact-crm-contact-module"
	],
	"./theme/dashboard/dashboard.module": [
		"./src/app/theme/dashboard/dashboard.module.ts",
		"theme-dashboard-dashboard-module"
	],
	"./theme/email/email.module": [
		"./src/app/theme/email/email.module.ts",
		"theme-email-email-module"
	],
	"./theme/extension/editor/editor.module": [
		"./src/app/theme/extension/editor/editor.module.ts",
		"theme-extension-editor-editor-module"
	],
	"./theme/extension/event-calendar/event-calendar.module": [
		"./src/app/theme/extension/event-calendar/event-calendar.module.ts",
		"advance-elements-advance-elements-module~categories-category-module~components-create-order-create-o~79e42dec",
		"common",
		"theme-extension-event-calendar-event-calendar-module"
	],
	"./theme/extension/file-upload-ui/file-upload-ui.module": [
		"./src/app/theme/extension/file-upload-ui/file-upload-ui.module.ts",
		"gift-cards-gift-cards-module~gift-message-design-category-gift-message-design-category-module~pages-~51b16377",
		"common",
		"theme-extension-file-upload-ui-file-upload-ui-module"
	],
	"./theme/extension/invoice/invoice.module": [
		"./src/app/theme/extension/invoice/invoice.module.ts",
		"theme-extension-invoice-invoice-module"
	],
	"./theme/forms/forms.module": [
		"./src/app/theme/forms/forms.module.ts",
		"common"
	],
	"./theme/map/map.module": [
		"./src/app/theme/map/map.module.ts",
		"theme-map-map-module"
	],
	"./theme/navigation/navigation.module": [
		"./src/app/theme/navigation/navigation.module.ts",
		"theme-navigation-navigation-module"
	],
	"./theme/simple-page/simple-page.module": [
		"./src/app/theme/simple-page/simple-page.module.ts",
		"theme-simple-page-simple-page-module"
	],
	"./theme/table/bootstrap-table/bootstrap-table.module": [
		"./src/app/theme/table/bootstrap-table/bootstrap-table.module.ts",
		"theme-table-bootstrap-table-bootstrap-table-module"
	],
	"./theme/table/data-table/data-table.module": [
		"./src/app/theme/table/data-table/data-table.module.ts",
		"theme-table-data-table-data-table-module"
	],
	"./theme/task/task.module": [
		"./src/app/theme/task/task.module.ts",
		"theme-task-task-module"
	],
	"./theme/ui-elements/advance/advance.module": [
		"./src/app/theme/ui-elements/advance/advance.module.ts",
		"theme-ui-elements-advance-advance-module"
	],
	"./theme/ui-elements/animation/animation.module": [
		"./src/app/theme/ui-elements/animation/animation.module.ts",
		"theme-ui-elements-animation-animation-module"
	],
	"./theme/ui-elements/basic/basic.module": [
		"./src/app/theme/ui-elements/basic/basic.module.ts",
		"theme-ui-elements-basic-basic-module"
	],
	"./theme/user/user.module": [
		"./src/app/theme/user/user.module.ts",
		"theme-user-user-module"
	],
	"./theme/widget/widget.module": [
		"./src/app/theme/widget/widget.module.ts",
		"theme-widget-widget-module"
	],
	"./tooltip/tooltip.module": [
		"./src/app/theme/ui-elements/basic/tooltip/tooltip.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"tooltip-tooltip-module"
	],
	"./transaction-by-customer/transaction-by-customer.module": [
		"./src/app/pages/reports/transaction-by-customer/transaction-by-customer.module.ts",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"transaction-by-customer-transaction-by-customer-module"
	],
	"./transaction-by-item/transaction-by-item.module": [
		"./src/app/pages/reports/transaction-by-item/transaction-by-item.module.ts",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"transaction-by-item-transaction-by-item-module"
	],
	"./transaction-by-store/transaction-by-store.module": [
		"./src/app/pages/reports/transaction-by-store/transaction-by-store.module.ts",
		"best-selling-best-selling-module~branches-branch-module~categories-category-features-category-featur~2b71bc22",
		"common",
		"transaction-by-store-transaction-by-store-module"
	],
	"./typography/typography.module": [
		"./src/app/theme/ui-elements/basic/typography/typography.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"typography-typography-module"
	],
	"./user-card/user-card.module": [
		"./src/app/theme/user/user-card/user-card.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"common",
		"user-card-user-card-module"
	],
	"./user-profile/user-profile.module": [
		"./src/app/theme/user/user-profile/user-profile.module.ts",
		"add-on-add-on-module~advance-elements-advance-elements-module~alert-alert-module~basic-list-basic-li~03faa16d",
		"other-datatable-other-datatable-module~task-issue-task-issue-module~task-list-task-list-module~theme~860ba759",
		"email-compose-email-compose-module~quill-edit-quill-edit-module~user-profile-user-profile-module",
		"common",
		"user-profile-user-profile-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;